export function deObfuscate(num: number): number {
  return num - 42746
}
